import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timeFromNow',
  standalone: true
})
export class TimeFromNowPipe implements PipeTransform {

  transform(value: any): any {
    let currentDate = new Date();
    const dateSent = new Date(value);

    const differenceInMinutes = (Date.UTC(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate(), currentDate.getHours(), currentDate.getMinutes()) - Date.UTC(dateSent.getFullYear(), dateSent.getMonth(), dateSent.getDate(), dateSent.getHours(), dateSent.getMinutes()) ) / (1000 * 60);
    // If greater than 2 days show in days. 2880 Minutes in 48 hrs
    if ((differenceInMinutes) > 2880) {
      return `${Math.floor(differenceInMinutes / 24 / 60)} Days`
    }
    // if less than 2 days but greater than 1 hour, show in hrs
    if (differenceInMinutes > 60) {
      return `${Math.floor(differenceInMinutes / 60)} Hours`
    }
    // if less than a hr show in minutes
    if (differenceInMinutes <= 60){
      return `${differenceInMinutes} Mins`
    }
  }
}
